export default __webpack_public_path__ + "static/media/change-oil.1db9f84f.jpeg";